import moment from 'moment'

export const AUDIT_PASS_SMS_TEMPLATES = [
  { value: 'brief', label: '样式1' },
  { value: 'detail', label: '样式2' }
]

export const AUDIT_REFUSE_SMS_TEMPLATES = [
  { value: 'brief', label: '样式1' },
  { value: 'detail', label: '样式2' }
]

export const SMS_PREFIX = '【中贸促信息技术】经贸活动云：'
const LEGACY_SMS_PREFIXES = [
  '【中贸促】经贸活动云：',
  SMS_PREFIX
]
const DEFAULT_ACTIVITY_NAME = '活动'
const DETAIL_DATE_FALLBACK = '活动开始时间请以报名系统为准'
const SIGN_END_DATE_FALLBACK = '活动报名截止时间请以报名系统为准'

function normalizeMeetingTitle (meeting) {
  if (!meeting || !meeting.title) {
    return DEFAULT_ACTIVITY_NAME
  }

  const title = String(meeting.title).replace(/[\r\n]+/g, ' ').trim()
  return title || DEFAULT_ACTIVITY_NAME
}

function formatMeetingStartDate (meeting) {
  if (!meeting || !meeting.startDate) {
    return ''
  }

  return moment(meeting.startDate).format('YYYY年M月D日')
}

function formatMeetingSignEndDate (meeting) {
  if (!meeting || !meeting.signSetting || !meeting.signSetting.signEndDate) {
    return ''
  }

  return moment(meeting.signSetting.signEndDate).format('YYYY年M月D日')
}

export function normalizeAuditSmsContent (text = '') {
  if (!text) {
    return ''
  }

  let normalized = String(text).trim()
  for (const prefix of LEGACY_SMS_PREFIXES) {
    if (normalized.startsWith(prefix)) {
      normalized = SMS_PREFIX + normalized.slice(prefix.length)
      break
    }
  }
  return normalized
}

export function buildAuditPassSmsContent (meeting, template) {
  const title = normalizeMeetingTitle(meeting)

  if (template === 'detail') {
    const startDate = formatMeetingStartDate(meeting) || DETAIL_DATE_FALLBACK
    return `${SMS_PREFIX}您报名的活动“${title}”已通过审核，该活动将于${startDate}开始，请准时参加。`
  }

  return `${SMS_PREFIX}您报名的活动“${title}”已通过审核，请准时参加活动。`
}

export function buildAuditRefuseSmsContent (meeting, template) {
  const title = normalizeMeetingTitle(meeting)

  if (template === 'detail') {
    const signEndDate = formatMeetingSignEndDate(meeting) || SIGN_END_DATE_FALLBACK
    return `${SMS_PREFIX}您报名的活动“${title}”未通过报名审核，该活动的报名截止日期为${signEndDate}。`
  }

  return `${SMS_PREFIX}您报名的活动“${title}”未通过报名审核。`
}



// WEBPACK FOOTER //
// ./src/util/smsTemplates.js